import { render, staticRenderFns } from "./UpdateGood.vue?vue&type=template&id=70a6aee7&scoped=true"
import script from "./UpdateGood.vue?vue&type=script&lang=js"
export * from "./UpdateGood.vue?vue&type=script&lang=js"
import style0 from "./UpdateGood.vue?vue&type=style&index=0&id=70a6aee7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a6aee7",
  null
  
)

export default component.exports